import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BubbleSortComponent } from './bubble-sort/bubble-sort.component';
import { CardsComponent } from './cards/cards.component';
import { TBubbleSortComponent } from './t-bubble-sort/t-bubble-sort.component';
import { BinarySearchComponent } from './binary-search/binary-search.component';
import { HelpComponent } from './help/help.component';


@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxChartsModule,
    SharedModule
  ], providers: [TopicService,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    BubbleSortComponent,
    CardsComponent,
    TExercisesComponent,
    TAllExercisesComponent,
    TBubbleSortComponent,
    BinarySearchComponent,
    HelpComponent
  ]
})
export class SortModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}

